<!--
 * @Author: name
 * @Date: 2022-07-13 15:57:51
 * @Description: 
-->
<template>
  <div class="apps">
    <section class="parallax-background mobile-display background fadeIn">
      <span class="white--text title-label font-weight-medium">{{
        $t("i18n.apps")
      }}</span>
    </section>
    <section id="service">
      <div class="py-8"></div>
      <v-container class="text-center">
        <!-- <h3 class="font-weight-medium mb-3 item-title">{{$t('i18n.service')}}</h3> -->
        <v-responsive class="mx-auto mb-4" width="56"></v-responsive>
        <v-responsive
          class="mx-auto font-weight-regular text-justify"
          max-width="1200"
          style="color: #000; text-indent: 2em; font-size: 20px"
          >{{ $t("i18n.aiServiceText") }}</v-responsive
        >
      </v-container>
    </section>
    <!--解决方案-->
    <CAS />
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: null,
      window: 0,
    };
  },
  components: {
    CAS:() => import("@/components/CAS"),
  },
  mounted() {
    var hash = window.location.hash;
    var index = hash.lastIndexOf("#");
    if (index != -1) {
      var id = hash.substring(index + 1, hash.length + 1);
      var div = document.getElementById(id);
      if (div) {
        div.scrollIntoView();
      }
    }
  },
  methods: {
    change(index) {
      this.window = index;
    },
  },
};
</script>
<style lang="scss" scoped>
.background {
  background: url(../assets/images/common/banner6.jpg);
  background-size: cover;
}

.tabs {
  display: flex;
  justify-content: space-around;
  flex-wrap: nowrap;
}
.active_tab {
  color: rgb(0, 0, 0) !important;
  font-size: 30px;
  text-decoration: none;
}
.content {
  // border: 1px solid #019fe8 !important;
  border-radius: 0px !important;
  min-height: 660px;
}
/* .content-light:hover {
  box-shadow: #019fe8 0 0 15px;
} */
.case-title {
  background: #019fe8;
  color: #fff !important;
  padding: 10px;
  font-size: 20px;
  font-weight: 500;
}
.active-title {
  background: #019fe8;
  color: #fff !important;
}
// .v-list-item {
//   border: 1px solid #019fe8;
// }
// .v-list {
//   padding: 0px;
// }
.data-title {
  background: #019fe8;
  color: #fff;
  padding: 10px;
  font-size: 20px;
  font-weight: 500;
}
</style>
